import { Badge } from '@/components/ui/badge';

const PAYMENT_STATUSES = {
  IN_REVIEW: 'in_review',
  APPROVED: 'approved',
  PROCESSING: 'processing',
  SCHEDULED: 'scheduled',
  PAID: 'paid',
  FAILED: 'failed',
  CANCELED: 'canceled',
} as const;

type PaymentStatus = (typeof PAYMENT_STATUSES)[keyof typeof PAYMENT_STATUSES];

const VARIANT_MAP: Record<
  string,
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  [PAYMENT_STATUSES.IN_REVIEW]: 'outline',
  [PAYMENT_STATUSES.APPROVED]: 'secondary',
  [PAYMENT_STATUSES.PROCESSING]: 'default',
  [PAYMENT_STATUSES.SCHEDULED]: 'default',
  [PAYMENT_STATUSES.PAID]: 'default',
  [PAYMENT_STATUSES.FAILED]: 'destructive',
  [PAYMENT_STATUSES.CANCELED]: 'outline',
};

const LABEL_MAP: Record<string, string> = {
  [PAYMENT_STATUSES.IN_REVIEW]: 'In Review',
  [PAYMENT_STATUSES.APPROVED]: 'Approved',
  [PAYMENT_STATUSES.PROCESSING]: 'Processing',
  [PAYMENT_STATUSES.SCHEDULED]: 'Scheduled',
  [PAYMENT_STATUSES.PAID]: 'Paid',
  [PAYMENT_STATUSES.FAILED]: 'Failed',
  [PAYMENT_STATUSES.CANCELED]: 'Canceled',
};

interface PaymentStatusBadgeProps {
  status: PaymentStatus | string;
  hasApprovalRequest?: boolean;
}

export default function PaymentStatusBadge({
  status,
  hasApprovalRequest,
}: PaymentStatusBadgeProps) {
  const isApprovalRequested =
    status === PAYMENT_STATUSES.IN_REVIEW && hasApprovalRequest;
  const variant = isApprovalRequested
    ? 'outline'
    : VARIANT_MAP[status] || 'outline';
  const label = isApprovalRequested
    ? 'Approval Requested'
    : LABEL_MAP[status] || status;

  return <Badge variant={variant}>{label}</Badge>;
}
